import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {FintechAddComponent} from "../fintech-add/fintech-add.component";
import {FintechService} from "../../../../services/fintech.service";
import {HttpClient} from "@angular/common/http";
import {FormBuilder} from "@angular/forms";
import {MatDialogRef} from "@angular/material/dialog";
import {Observable, of, switchMap} from "rxjs";  // ES Module import
import dropin from 'braintree-web-drop-in';

@Component({
    selector: 'app-fintech-add-braintree',
    templateUrl: './fintech-add-braintree.component.html',
    styleUrl: './fintech-add-braintree.component.scss'
})
export class FintechAddBraintreeComponent extends FintechAddComponent implements OnInit {
    braintreeToken;
    dropinInstance;

    constructor(fintechService: FintechService,
                http: HttpClient,
                formBuilder: FormBuilder,
                changeDetectorRef: ChangeDetectorRef,
                private dialogRef: MatDialogRef<FintechAddBraintreeComponent>) {
        super(fintechService, http, formBuilder, changeDetectorRef);
    }

    ngOnInit(): void {
        const obs$ = this.fintechService.getPayerToken().pipe(
            switchMap( payerToken => {
                console.log("payerToken=" + payerToken);
                const url = "https://pay.signage.me:8443/braintree/CreateBraintreeToken";
                const options = {token: payerToken};
                return this.http.post(url, options);
            }),
            switchMap( bt => {
                this.braintreeToken = (<any>bt).braintreeToken;
                console.log("braintreeToken="+this.braintreeToken);
                dropin.create({
                    authorization: this.braintreeToken,
                    container: '#braintree-container',
                    card: {
                        cardholderName: true
                    }
                }, (err, dropinInstance) => {
                    console.log(err);
                    this.dropinInstance = dropinInstance;
                });

                return of('a');
            } )
        );


        obs$.subscribe();

        /*

         */
    }

    onBillingCancel() {
        this.dialogRef.close(null);
    }


    onBillingSubmit() {
        this.payMethodInfo.address1 =  this.billForm.value.address1;
        this.payMethodInfo.address2 =  this.billForm.value.address2;
        this.payMethodInfo.city =  this.billForm.value.city;
        this.payMethodInfo.state =  this.billForm.value.state;
        this.payMethodInfo.postalCode =  this.billForm.value.postalCode;
        this.payMethodInfo.country =  this.billForm.value.country;


        this.messageColor = "white";
        this.billMessage = "Please wait updating....";

        let payerToken;
        const obs$ = this.fintechService.getPayerToken().pipe(
            switchMap( pt => {
                payerToken = pt;
                return new Observable<any>(sub => {
                    this.dropinInstance.requestPaymentMethod().then((payload) => {
                        if (payload && payload.nonce) {
                            this.fintechService.setBusy(true);
                            sub.next(payload);
                            sub.complete();
                        }
                    });
                })
            }),
            switchMap( payload => {
                const billAddress = {
                    address1: this.payMethodInfo.address1,
                    address2: this.payMethodInfo.address2,
                    city: this.payMethodInfo.city,
                    state: this.payMethodInfo. state,
                    postalCode: this.payMethodInfo.postalCode,
                    country: this.payMethodInfo.country
                };

                const url = "https://pay.signage.me:8443/braintree/createPaymentMethod";
                const options = {
                    token: payerToken,
                    PaymentMethodNonce: payload.nonce,
                    billingAddress: billAddress
                };
                return this.http.post(url, options);
            }),
            switchMap(ret => {
                const data: any = ret;
                this.payMethodInfo.payMethodId = data.payMethodId;
                this.payMethodInfo.cardholder = data.cardholder;
                this.payMethodInfo.last4 = data.last4;
                this.payMethodInfo.expiration = data.expiration;
                this.payMethodInfo.address1 = data.address1;
                this.payMethodInfo.address2 = data.address2;
                this.payMethodInfo.city = data.city;
                this.payMethodInfo.state = data.state;
                this.payMethodInfo.postalCode = data.postalCode;
                this.payMethodInfo.country = data.country;
                this.messageColor = "white";
                this.billMessage = "";
                this.dialogRef.close(this.payMethodInfo);
                this.fintechService.setBusy(false);
                return of('a');
            })
        );

        obs$.subscribe();


    }
}

